import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const NOTE_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idNoteRepository',
	singular: 'Note',
};

export const NOTE_REPOSITORY_TEMPLATE_PROPERTIES: PropertyDefinition[] = [
	{
		id: 'idNoteRepositoryTitleProperty',
		parentId: NOTE_REPOSITORY.id,
		type: EntityType.PropertyDefinitionString,
		slug: 'title',
		label: '',
		required: true,
		autoFocus: true,
		placeholder: 'A fresh idea',
	}
];
